<p
  #body
  class="m-0 w-full text-primary whitespace-pre-line"
  [class.line-clamp-5]="!expanded()"
  data-testid="expandable-text-body">
  {{ text() }}
</p>
@if (overflowing() || expanded()) {
  <button
    type="button"
    class="text-sm font-semibold text-button-secondary-color hover:underline"
    [attr.aria-expanded]="expanded()"
    data-testid="expandable-text-toggle"
    (click)="toggle()">
    {{ expanded() ? '- Show less' : '+ Show more' }}
  </button>
}
